module.exports = function(ngModule) {
  require('./main.js')(ngModule);
};



//////////////////
// WEBPACK FOOTER
// ./js/directives/index.js
// module id = 19
// module chunks = 0